import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "section"]

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null,
      rootMargin: "-15% 0px -80% 0px", // Trigger when the top of the element hits the top 15-20% of the viewport
      threshold: 0
    })

    this.sectionTargets.forEach(section => {
      this.observer.observe(section)
    })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.activateLink(entry.target.id)
      }
    })
  }

  activateLink(id) {
    const activeClasses = ["text-zinc-900", "dark:text-zinc-100", "bg-zinc-100/50", "dark:bg-zinc-800/50"]
    const inactiveClasses = ["text-zinc-600", "dark:text-zinc-400"]

    this.linkTargets.forEach(link => {
      const href = link.getAttribute("href")
      if (href && href === `#${id}`) {
        link.classList.remove(...inactiveClasses)
        link.classList.add(...activeClasses)
      } else {
        link.classList.remove(...activeClasses)
        link.classList.add(...inactiveClasses)
      }
    })
  }
}
